export default __webpack_public_path__ + "static/media/internship.5f434a29.svg";